import {
  faChartLineUp,
  faArrowDownToLine,
  faUpload,
  faChartPieSimple,
  faChartSimple,
  faChartSimpleHorizontal,
  faChartColumn,
  faChartMixed,
  faChartPie,
  faChartArea,
  faGridHorizontal,
  faSparkles,
} from "@fortawesome/pro-light-svg-icons";
import { AnalyticsNavItem } from "../../types/dtos/users/SignedInUserDto";
import SubNavItem from "../../types/nav/SubNavItem";
import AppRoutes from "../AppRoutes";

const AnalyticsSubNavItems = (
  pages: AnalyticsNavItem[],
  canAccessClassicReports: boolean,
  canUserUploadScores: boolean,
  canAccessExports: boolean,
  navType: "LEFT-NAV" | "TOUCH",
  hasAiAnalytics: boolean = false,
): SubNavItem[] => {
  const translationIdentifierPrefix = `Nav.${
    navType === "LEFT-NAV" ? "LargeScreen" : "Touch"
  }.Analytics.`;

  const output: SubNavItem[] = [
    {
      title: translationIdentifierPrefix + "Usage",
      translateTitle: true,
      url: AppRoutes.analytics.usage,
      icon: faChartLineUp,
    },
  ];

  const pageIcons = [
    faChartSimple,
    faChartPieSimple,
    faChartColumn,
    faChartMixed,
    faChartSimpleHorizontal,
    faChartPie,
    faChartArea,
  ];

  if (pages) {
    pages.forEach((p, index) =>
      output.push({
        title: p.pageTitle,
        translateTitle: false,
        url: AppRoutes.analytics.dynamicPage.generateRoute(p.pageId.toString()),
        icon: pageIcons[index % pageIcons.length],
      }),
    );
  }

  if (hasAiAnalytics) {
    output.push({
      title: "AI Insights",
      translateTitle: false,
      url: AppRoutes.analytics.aiQuery,
      icon: faSparkles,
    });
  }

  if (navType === "LEFT-NAV") {
    if (canAccessExports) {
      output.push({
        title: translationIdentifierPrefix + "Exports",
        translateTitle: true,
        url: AppRoutes.analytics.exports,
        icon: faArrowDownToLine,
      });
    }

    if (canAccessClassicReports) {
      output.push({
        title: translationIdentifierPrefix + "Classic",
        translateTitle: true,
        url: AppRoutes.analytics.classic,
        icon: faGridHorizontal,
      });
    }

    if (canUserUploadScores) {
      output.push({
        title: translationIdentifierPrefix + "ScoreUploader",
        translateTitle: true,
        url: AppRoutes.analytics.scoreUploader,
        icon: faUpload,
      });
    }
  }

  return output;
};

export default AnalyticsSubNavItems;
